import {
    getModule,
    Module,
    Mutation,
    Action,
    VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import {SearchResult} from '@/store/models';
import * as api from '../api';

@Module({
    namespaced: true,
    name: 'search',
    store,
    dynamic: true,
})
class SearchModule extends VuexModule {
    pending: boolean = false;
    term: string = '';
    result: SearchResult | null = null;

    @Action
    async search(term: string) {
        this.setPending(true);
        this.setTerm(term);
        if (term) {
            this.setResult(await api.searchCompanies(term));
        } else {
            this.setResult(null);
        }
        this.setPending(false);
    }

    @Mutation
    setPending(pending: boolean) {
        this.pending = pending;
    }

    @Mutation
    setTerm(term: string) {
        this.term = term;
    }

    @Mutation
    setResult(result: SearchResult | null) {
        this.result = result;
    }

}

export default getModule(SearchModule);
